export function AuthLoadingScreen({ title, description }: { title: string; description: string }) {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				width: '100%',
			}}
		>
			<div style={{ textAlign: 'center' }}>
				{/* Spinner */}
				<div
					style={{
						width: 32,
						height: 32,
						margin: '0 auto 20px',
						border: '3px solid rgba(128,128,128,0.2)',
						borderTopColor: 'currentColor',
						borderRadius: '50%',
						animation: 'auth-spin 0.6s linear infinite',
					}}
				/>
				<div style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>{title}</div>
				<div style={{ fontSize: 14, opacity: 0.6 }}>{description}</div>
				<style>{`@keyframes auth-spin { to { transform: rotate(360deg) } }`}</style>
			</div>
		</div>
	);
}
